import * as React from 'react';
import { MenuItem, Select } from "@mui/material";


/**
 * Renders the options for the chat component.
 * @param projectsInfo - Array of project information.
 * @param projectsInfoLoading - Flag indicating if project information is loading.
 * @param handleProjectsChatStream - Function to handle projects chat stream.

 */
const PopperOptions = ({
  projectsInfo,
  projectsInfoLoading,
  handleProjectsChatStream,
}: any) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  /**
   * Handles the click event of the options button.
   * @param event - The click event.
   */
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popper' : undefined;

  const [project, setProject] = React.useState(0);
  /**
   * Handles the change event of the project select input.
   * @param event - The change event.
   */
  const handleChange = (event: any) => {
    setProject(event.target.value);
    handleProjectsChatStream(event.target.value);
    handleClose();
  };

  /**
   * Handles the file upload event.
   * @param e - The file upload event.
   */
  const onUpload = (e: any) => {
    // Handle file upload
  };

  /**
   * Closes the options popper.
   */
  const handleClose = () => {
    setAnchorEl(null);
  }

  /**
   * Effect to handle setting the default project and calling the handleProjectsChatStream.
   * Prioritizes "PMR Investor Guidelines" as the default project, falls back to first project if not found.
   */
  React.useEffect(() => {
    if (!projectsInfoLoading && projectsInfo && projectsInfo.length > 0) {
      // Try to find "PMR Investor Guidelines" project
      const pmrInvestorProject = projectsInfo.find(
        (proj: any) => proj.ProjectName === "PMR Investor Guidelines"
      );
      
      // Use PMR Investor Guidelines if found, otherwise use first project
      const defaultProjectId = pmrInvestorProject ? pmrInvestorProject.ID : projectsInfo[0].ID;
      setProject(defaultProjectId);
      handleProjectsChatStream(defaultProjectId);
    }
  }, [projectsInfo]);


  return (
    <Select
      labelId="demo-simple-select-label"
      id="demo-simple-select"
      // value={project !== undefined && project !== null && project !=0 ? project : -1}
      value={
        project !== undefined && project !== null && project !== 0 
          ? project 
          : (!projectsInfoLoading && projectsInfo && projectsInfo.length > 0 
              ? (projectsInfo[0].ID)
              : -1)
      }
      placeholder="Select from Projects"
      onChange={handleChange}
      style={{ width: '300px', fontWeight: '500' }}
    >
      <MenuItem value={
        -1
      }>
        Select a Project</MenuItem>
        {/* <MenuItem value={1}>Twitch</MenuItem>   */}
      {
        !projectsInfoLoading && projectsInfo && projectsInfo?.map((project: any, index: number) => {
          if (project.ProjectName !== 'CI Heat Data' && project.ProjectName !== 'Claims')
            return (
              <MenuItem key={index} value={project.ID} style={{ fontWeight: '500' }}>{project.ProjectName}</MenuItem>
            )
        })
      }
    </Select>
  );
}

export default PopperOptions;